// extracted by mini-css-extract-plugin
module.exports = {"container":"FXnf","headerLink":"FXkx","list":"FXar","imageLink":"FXol","header":"FXap","itemLink":"FXzp"};